import React, { useEffect, useState } from "react";
import logo from "../images/EnvironmentalLabsLogoHorizontal.png";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LogoutUser } from "../services/usersService";

export default function Header() {
  const [userTitle, setUserTitle] = useState("");
  const handleSignOut = async () => {
    await LogoutUser();
    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("lastUser");
    localStorage.removeItem("sessionExpiryWarningsShown");
    window.location.pathname = "/";
  };

  useEffect(() => {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const userObject = JSON.parse(loggedInUser);
    setUserTitle(userObject.aliasName);
    document.title = "VLP Extent";
  }, []);

  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <a href="/">
          <img
            src={logo}
            alt="ELI Logo"
            style={{ maxHeight: "55px", marginTop: "10px" }}
          />
        </a>
        <Link className="navbar-item" to="/vlp-extend">
          Home
        </Link>
        <Link className="navbar-item" to="/vlp-extend/micro-in">
          Micro In
        </Link>
        <Link className="navbar-item" to="/vlp-extend/micro-out">
          Micro Out
        </Link>
        {!isMobile && (
          <Link className="navbar-item" to="/vlp-extend/batch-manager">
            Batch Manager
          </Link>
        )}
        {!isMobile && (
          <Link className="navbar-item" to="/vlp-extend/new-order">
            New Order
          </Link>
        )}

       
          <Link className="navbar-item" to="/vlp/lab-orders">
            VLP
          </Link>
       
      </div>
      <div className="navbar-end">
        <div className="navbar-item has-dropdown is-hoverable">
          <a className="navbar-link">
            <FontAwesomeIcon icon={faUser} color="green" size="lg" />
            <span className="ml-2">{userTitle}</span>
          </a>
          <div className="navbar-dropdown">
            {/* <Link className="navbar-item" to="/vlp/lab-orders">
              VLP
            </Link> */}
            <a className="navbar-item" onClick={handleSignOut}>
              Sign Out
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
